(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('AstreintePlanifieController', AstreintePlanifieController);

    AstreintePlanifieController.$inject = ['$state', 'AstreintePlanifie', 'Technicien' ,'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function AstreintePlanifieController($state, AstreintePlanifie, Technicien, ParseLinks, AlertService, paginationConstants, pagingParams) {
        $(document).ready(function () {
            $('#filterTechnicien').select2();
            $('#filterTechnicien').on('select2:select', function (e) {
                vm.filterTechnicien = $('#filterTechnicien').val();
                vm.search();
            });
        });

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.filterTechnicien = pagingParams.technicien;
        vm.filterYear = pagingParams.year;
        vm.filterMonth = pagingParams.month;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.search=search;
        vm.yearDispo = [];
        vm.parseNumberToMonth = parseNumberToMonth;

        loadAll();
        loadTechniciens();
        createArrayOfYear();

        function parseNumberToMonth(month) {
            var today = Date.now();
            var date = moment(today);
            date.set('Month',month);
            return date.format("MMMM");
        }

        function loadAll () {
            AstreintePlanifie.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.astreintePlanifies = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function loadTechniciens(){
            Technicien.technicienEnabledHistory({ }, function onSuccess(data, headers) {
                vm.techniciens = data;
            }, function onError(error) {
                AlertService.error(error.data.message);
            });
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                technicien: vm.filterTechnicien,
                year: vm.filterYear,
                month: vm.filterMonth
            });
        }

        function search(){
            transition();
        }

        function createArrayOfYear() {
            var currentDate = new Date();
            for (var i = 2020; i <= currentDate.getFullYear()+1 ; i++) {
                vm.yearDispo.push(i);
            }
        }
    }
})();
